import { CLAIMS_POSTING_INIT_LOADING, CLAIMS_POSTING_INIT_SUCCESS, CLAIMS_POSTING_INIT_FAIL } from '@/store/types'

export const post = {
  [CLAIMS_POSTING_INIT_LOADING](state) {
    state.posting.init = 0
    state.posting.initErr = []
    state.posting.menu = {}
  },
  [CLAIMS_POSTING_INIT_SUCCESS](state, data) {
    state.posting.init = 1
    state.posting.initErr = []
    state.posting.menu = data.menu
  },
  [CLAIMS_POSTING_INIT_FAIL](state, error) {
    state.posting.init = 2
    state.posting.initErr = error
    state.posting.menu = {}
  }
}
